<template>
  <div>
    <div class="container-fluid finalCheckout mt-5 pt-5">
      <div class="row">
        <div class="col-lg-8">
          <div class="section-contact">
            <h6 v-b-toggle.contact v-if="isUserLoggedIn" class="text-pink">
              {{ $t("CHECKOUT") }}
            </h6>
            <h6 v-b-toggle.contact v-else class="text-pink">
              {{ $t("CHECKOUT_AS_GUEST") }}
            </h6>
            <b-collapse id="contact" visible>
              <div class="small mb-2">
                <div>
                  <div>
                    <p class="text-pink">
                      <!-- <strong>{{ $t("FOR_PAYMENT") }}</strong> -->
                      {{ $t("PLEASE_MAKE_SURE_THAT_YOU_ENTER") }}
                      <!-- <br />{{ $t("WE_ONLY_ACCEPT") }} -->
                    </p>
                    <p style="color: black">
                      {{ $t("IF_YOU_ARE_A_REGISTERED_USER") }}
                    </p>
                  </div>
                </div>
              </div>
              <form
                data-vv-scope="bookUser"
                class="col-md-12 col-lg-10 col-xl-11 px-0"
              >
                <div class="w-100 mb-3">
                  <div class="row">
                    <div class="col-md-6 mb-2 mb-md-0">
                      <!-- <input
                        type="text"
                        v-model="email"
                        class="form-control"
                        placeholder="Your Email Address"
                      /> -->
                      <input
                        v-validate="'required|email'"
                        name="email"
                        v-on:keyup="onKeyUp($event, 'email')"
                        v-model="email"
                        type="text"
                        :placeholder="$t('ENTER_YOUR_EMAILADDRESS')"
                        class="form-control"
                      />
                      <div
                        v-show="errors.has('bookUser.email')"
                        class="fs-11 text-danger my-2"
                      >
                        {{ errors.first("bookUser.email") }}
                      </div>
                    </div>
                    <div class="col-md-6 mb-2 mb-md-0">
                      <div class="">
                        <VuePhoneNumberInput
                          v-model="mobile"
                          :default-country-code="
                            countryList.find(
                              (o) => o.phonecode == countryISOCode
                            ) &&
                            countryList.find(
                              (o) => o.phonecode == countryISOCode
                            ).isoCode
                          "
                          @update="onKeyUp($event, 'mobile')"
                          id="phoneNumber1"
                        />

                        <!-- <div class="country-code-drop">
                          <b-dropdown
                            class="pc-input form-control"
                            variant="default"
                            slot="append"
                            text="+91"
                          >
                            <b-dropdown-item class
                              >Bahrain (+973)</b-dropdown-item
                            >
                            <b-dropdown-item class>UAE (+971)</b-dropdown-item>
                            <b-dropdown-item class>India (+91)</b-dropdown-item>
                            <b-dropdown-item class>Egypt (+20)</b-dropdown-item>
                            <b-dropdown-item class
                              >Kuwait (+965)</b-dropdown-item
                            >
                            <b-dropdown-item class>Oman (+968)</b-dropdown-item>
                            <b-dropdown-item class
                              >Qatar (+974)</b-dropdown-item
                            >
                            <b-dropdown-item class>Egypt (+20)</b-dropdown-item>
                            <b-dropdown-item class
                              >Saudi Arabia (+966)</b-dropdown-item
                            >
                            <b-dropdown-item class>Egypt (+20)</b-dropdown-item>
                            <b-dropdown-item class>Other</b-dropdown-item>
                          </b-dropdown>
                        </div> -->
                        <!-- <div>
                          <input
                            class="form-control"
                            type="text"
                            v-model="mobile"
                            v-validate="'required'"
                            placeholder="Mobile Number"
                          />
                          <input
                            v-validate="'required|min:8|max:10'"
                            name="Phone Number"
                            v-on:keyup="onKeyUp($event, 'mobile')"
                            v-model="mobile"
                            type="number"
                            :placeholder="$t('ENTER_YOUR_CONTACTNUMBER')"
                            class="form-control"
                          />
                        </div> -->
                      </div>
                      <div
                        v-show="errors.has('bookUser.Phone Number')"
                        class="fs-11 text-danger my-2"
                      >
                        {{ errors.first("bookUser.Phone Number") }}
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <p class="text-pink d-none" style="font-size: 10px">
                    Kindly note, Payment made via Debit or Credit card should be
                    associated with the same email id &amp; phone number as
                    registered with your card issuing bank. Registered users
                    will get the ticket confirmation on email id &amp; mobile
                    number used while registering with Cineco.
                  </p>
                </div>
                <div class="w-100 mb-3" :class="isRTL ? 'text-right' : ''">
                  {{ $t("ALREADY_A_MEMBER") }}
                  <a
                    v-b-modal.signIn
                    @contextmenu="handler($event)"
                    class="text-pink"
                    style="cursor: pointer"
                  >
                    <u>{{ $t("LOGIN") }}&nbsp;</u> </a
                  >Or
                  <a
                    v-b-modal.signUp
                    @contextmenu="handler($event)"
                    class="text-pink"
                    style="cursor: pointer"
                  >
                    <u>{{ $t("REGISTER") }}&nbsp;</u> </a
                  >{{ $t("NOW_FOR_MORE") }}
                </div>
                <div
                  class="align-items-center w-100 mb-3 d-none"
                  :style="isRTL ? 'gap:10px' : ''"
                >
                  <input
                    type="checkbox"
                    id="guestCheckoutTerms"
                    v-model="conditions"
                    v-on:change="onKeyUp($event, 'conditions')"
                  />
                  <label for="guestCheckoutTerms" class="mb-0">
                    {{ $t("I_ACCEPT_THE") }}
                    <router-link target="_blank" to="/tnc" class="text-pink">
                      &nbsp;
                      <u>{{ $t("TERMS_CONDITIONS") }}</u>
                    </router-link>
                  </label>
                </div>
                <div class="small mb-1 text-muted d-none">
                  {{ $t("OPERATIONAL_TERMS_CONDITIONS") }}
                </div>
                <ul class="tnc d-none">
                  <li :class="isRTL ? 'text-right' : ''">
                    {{ $t("TICKET_COMPULSORY") }}
                  </li>
                  <li :class="isRTL ? 'text-right' : ''">
                    {{ $t("AGE_RESTRISTIONS") }}
                  </li>
                  <li :class="isRTL ? 'text-right' : ''">
                    {{ $t("AT_THE_CINEMA_PROOF") }}
                  </li>
                  <li :class="isRTL ? 'text-right' : ''">
                    {{ $t("RETURNS_EXCHANGE") }}
                  </li>
                  <li :class="isRTL ? 'text-right' : ''">
                    {{ $t("DECISIONS_TAKEN_CINEMAS") }}.
                  </li>
                  <li :class="isRTL ? 'text-right' : ''">
                    {{ $t("OUTSIDE_FOOD_BEVERAGES") }}
                  </li>
                </ul>
                <div class="w-100 d-flex">
                  <button
                    class="btn-confirm"
                    @click="validateBeforeSubmit('bookUser')"
                    type="button"
                    :disabled="checkoutButtonStatus ? false : true"
                    :class="checkoutButtonStatus ? 'active' : ''"
                  >
                    Continue
                  </button>
                </div>
              </form>
            </b-collapse>
          </div>
          <!-- OFFERS SECTION FINAL  -->
          <section
            class="py-2 cursor-pointer section-offer mt-3 offers-collapse"
          >
            <h6
              v-b-toggle.offers_collapse
              class="py-2 font-weight-bold mb-0 c-pointer text-pink"
            >
              OFFERS AND PROMOCODE
            </h6>

            <b-collapse id="offers_collapse">
              <div class="offers-grid">
                <div>
                  <input
                    v-on:keyup="onKeyUp($event, 'offer')"
                    type="text"
                    v-model="voucherCode"
                    class="voucher-input mt-3"
                    placeholder="Enter Voucher Code"
                  />
                  {{ this.voucherCode }}

                  <div class="font-weight-bold py-2" v-b-modal.applycoupon>
                    <img
                      class="mr-2 align-top"
                      src="@/assets/img/svg/discount.svg"
                      height="25px"
                      width="25px"
                    />Apply Promo Code
                  </div>

                  <!-- <div class="d-flex align-items-center mb-2">
                      <img
                        v-if="promoApplied"
                        src="@/assets/img/icons/offer.svg"
                        height="18"
                        width="16"
                      />
                      <img
                        v-if="
                          !promoApplied &&
                            promoCode.errorInputMessage.length > 0
                        "
                        src="@/assets/img/icons/invalid-offer.svg"
                        height="18"
                        width="16"
                      />
                      <div v-if="promoApplied" class="text-success ml-1 lh-1">
                        Voucher Applied Sucessfully
                      </div>
                      <div v-if="!promoApplied" class="text-danger ml-1 lh-1">
                        {{ promoCode.errorInputMessage }}
                      </div>
                    </div> -->
                </div>
                <button
                  class="btn btn-confirm"
                  :class="voucherCode ? 'btn btn-pink' : 'disabled'"
                  @click="applyVoucher()"
                >
                  APPLY
                </button>
              </div>
              <p>{{ this.voucherMsg }}</p>
            </b-collapse>
          </section>

          <div
            class="section-payment mt-4"
            v-if="this.showPaymentCollapse"
            id="payment-mode-section"
          >
            <h6 v-b-toggle.payment class="text-pink">SELECT PAYMENT MODE</h6>

            <b-collapse id="payment" visible class="text-center">
              <div
                class="
                  btn-group
                  payment-mode-group
                  qatar-payment-mode
                  btn-group-toggle
                  text-center
                "
              >
                <label
                  v-for="(data, index) in this.payment_options"
                  :key="index"
                  :class="
                    index == active
                      ? 'btn btn-secondary active'
                      : 'btn btn-secondary'
                  "
                  v-on:click="setActive(index)"
                >
                  <img :src="data.image" alt="card" class="card-icon-img" />
                  {{ data.title }}
                </label>
              </div>
              <div v-if="this.countryISOCode == 974" class="d-none">
                <div
                  :key="index"
                  v-for="(data, index) in this.payment_options"
                  class="
                    btn-group
                    payment-mode-group
                    btn-group-toggle
                    text-center
                  "
                >
                  <!-- <img :src=data.image
 alt="card" class="card-img" margin-right="8px"/>
                  {{ data.title }} -->
                  <div>
                    <label
                      :class="
                        index + 'C' == active1
                          ? 'btn btn-secondary active'
                          : 'btn btn-secondary'
                      "
                      v-on:click="setActive(index, 'C')"
                    >
                      <img
                        v-if="data.title == 'CREDIT CARD'"
                        src="@/assets/img/qatar-credit.png"
                      />
                      {{ data.title }}
                    </label>
                  </div>
                  <div>
                    <label
                      :class="
                        index + 'D' == active1
                          ? 'btn btn-secondary active'
                          : 'btn btn-secondary'
                      "
                      v-on:click="setActive(index, 'D')"
                    >
                      <img
                        src="@/assets/img/qatar-debit.png"
                        alt="card"
                        width="50px"
                        height="18px"
                        margin-right="8px"
                      />
                      Debit Card
                    </label>
                  </div>
                </div>
              </div>

              <div class="text-center">
                <button
                  class="btn btn-pink mt-5 px-5 text-center"
                  v-on:click="pay()"
                >
                  Proceed to pay
                </button>
              </div>
            </b-collapse>
          </div>
        </div>
        <div class="col-md-12 col-lg-4 mb-3 px-0 px-md-3">
          <div class="sticky-selected-movie-details">
            <div class="section-booking pb-0">
              <h6 class="font-weight-bold mb-3">BOOKING SUMMARY</h6>
              <div class="d-flex">
                <div class="img_poster mr-2">
                  <img :src="base_url + this.e_img" class="w-100" />
                </div>
                <div class="">
                  <div class="movieTitle mb-2">{{ this.e_name }}</div>
                  <div class="font-weight-bold">
                    <span
                      >{{ moment(this.es_date).format("MMM DD") }},
                      {{ moment(this.es_date).format("YYYY") }}</span
                    >
                    <span class="mx-1">|</span>
                    <span>{{
                      moment(this.es_time, "h:mm a").format("h:mm a")
                    }}</span>
                  </div>
                  <div>
                    <span>{{ this.e_venue.ev_address }}</span>
                  </div>

                  <!-- <div class="b">
                    {{ this.getSelectedSeatName }}
                  </div> -->
                </div>
              </div>
              <hr />

              <div>
                <div
                  class="tickets-grid text-muted small mb-2 font-weight-bold"
                >
                  <div>BOOKING DETAILS</div>
                  <div class="text-right">Amount</div>
                </div>
                <!-- {{ JSON.stringify(this.getSelectedSeats)}} -->
                <div
                  v-for="(data, index) in this.getSelectedSeats"
                  :key="index"
                  class="tickets-grid"
                >
                  <template v-if="data.qty != 0">
                    <p class="">
                      {{ data.st_name }} X {{ data.no_of_seat }}
                      <span v-if="data.sl_name != ''"
                        ><br />{{ data.sl_name }}</span
                      >
                    </p>
                    <p class="text-right">
                      {{ data.currency }} {{ data.price }}
                    </p>
                  </template>
                </div>
              </div>
              <div class="totalAmount mb-3" v-if="discount > 0">
                <h6 class="text-pink">Promocode ({{ voucherDetails.voucher_code }})</h6>
                <h6>
                  <span class="mr-1">{{ this.currencyCode }}</span>
                  {{ this.discount.toFixed(2) }}
                </h6>
              </div>
              <div class="totalAmount mb-3">
                <h6 class="text-pink">Amount Payable</h6>
                <h6>
                  <span class="mr-1">{{ this.currencyCode }}</span>
                  {{ this.paymentTotal.toFixed(2) }}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script>
import Slick from "vue-slick";
import VuePhoneNumberInput from "vue-phone-number-input";
import countryCodes from "@/helper/countryCodes.js";

import { makeRequest, makeRequestDirect } from "@/helper/internet.js";
import { mapState, mapGetters, mapActions } from "vuex";
import { EVENT_URL } from "@/helper/constant.js";
import moment from "moment";
import { TokenService, CountryService } from "@/services/storage.service";
import { EventBus } from "@/main";

export default {
  components: {
    Slick,
    VuePhoneNumberInput,
  },

  data() {
    return {
      discount: 0,
      email: "",
      mobile: "",
      countryList: countryCodes,
      isUserLoggedIn: "",
      countryCode: "",
      active: 0,
      active1: 0,
      conditions: false,
      showPaymentCollapse: false,
      e_name: "",
      e_img: "",
      genre: [],
      es_date: "",
      es_time: "",
      e_venue: "",
      getSelectedSeatName: "",
      getSelectedSeats: [],
      currencyCode: "",
      moment,
      paymentTotal: 0,
      paymentTotalBeforeDiscount: 0,
      payment_options: [],
      url: EVENT_URL,

      base_url: "",
      status: {
        emailStatus: false,
        phoneNumberStatus: false,
        offer: false,
      },
      modal: {
        signIn: false,
        guestLogin: false,
        payment: false, //make false
        payUsingWallet: false,
        userTicketsDetails: false,
      },
      voucherCode: "",
      voucherMsg: "",
      voucherDetails: "",
    };
  },

  mounted() {
    const { reseverID } = this.$route.params;
    /// set Cookies
    this.$cookies.set("reseverID", reseverID, 600);
    console.log("getSelectedSeats", reseverID);
    this.getPaymentOptions();
    this.getReserveDetails(reseverID);
    EventBus.$on("onProfileSuccess", () => {
      this.getUserDetails();
      // this.countryList = countryCodes;
    });
    this.getUserDetails();
  },
  beforeRouteLeave(to, from, next) {
    this.removeAllSelectedSeats([]);
    next();
  },
  destroyed() {
    document.body.classList.remove("bg-white");
  },
  computed: {
    ...mapGetters(["isRTL"]),
    checkoutButtonStatus() {
      console.log(this.status.phoneNumberStatus);
      return !this.onErrorMeesage &&
        this.status.emailStatus &&
        this.status.phoneNumberStatus
        ? // this.conditions
          true
        : false;
    },
  },
  watch: {},
  created() {},
  methods: {
    ...mapActions([
      "addSelectedEvent",
      "addSelectedSchedule",
      "addSelectedSeats",
      "removeSelectedSeats",
      "addSelectedSeatName",
      "removeAllSelectedSeats",
    ]),

    getUserDetails: function (callback) {
      let countryData = CountryService.getCountry();
      this.countryISOCode = countryData.CountryISOCode;
      let payload = {};
      makeRequest("/GetProfile", "POST", null, payload)
        .then((result) => {
          const { error, res } = result;
          if (!error && res.status) {
            console.log(
              "Hello get User Details Data on my account  >>",
              res.data
            );
            // userDetails
            this.email = res.data.Email;
            this.mobile = res.data.Mobile;
            this.countryCode = res.data.CountryCode;
            // this.userName = res.data.UserName;
            // this.modal.payUsingWallet = false;
            this.onKeyUp(null, "email");
            this.isUserLoggedIn = true;
            // this.onKeyUp(null, "mobile");
            this.status.phoneNumberStatus = true;
            //   this.userDetails.phoneNumber = data.userDetails.MobileNo.replace(
            //       /\D/g,
            //       ""
            //   );
            // if (callback) {
            //   callback();
            // }
            //   this.userDetails.profilePic =
            //       data.userDetails.ProfileURl.length > 0
            //           ? data.userDetails.ProfileURl
            //           : "/images/svg/icon-profile.svg";
            //   this.loginData.loginInput.email = data.userDetails.Email;
          } else {
            console.log("error from res", res.message);
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },
    pay() {
      const { reseverID } = this.$route.params;
      // console.log("email", this.email, this.validateEmail(this.email));
      // if (this.email == "" || !this.validateEmail(this.email)) {
      //   this.$toasted.show("Enter a valid Email Address");
      //   setTimeout(() => {
      //     this.$toasted.clear();
      //   }, 5000);
      // } else if (this.mobile == "" || this.mobile.length < 8) {
      //   this.$toasted.show("Enter a valid Mobile");
      //   setTimeout(() => {
      //     this.$toasted.clear();
      //   }, 5000);
      // } else {
      let that = this;
      let data = {
        user_info: {
          email: this.email,
          mobile: this.mobile,
        },
      };

      // "user_info":{
      // "email":"santoshbhagat82@gmail.com",
      // "mobile":"9892511533"
      makeRequest(
        "/v1/event/updatereserve/" + reseverID,
        "POST",
        null,
        data,
        this.url,
        false
      ).then((response) => {
        window.location.href =
          that.payment_options[that.active].redirect_url +
          "&event_reserve_id=" +
          reseverID;
      });
      // }
    },
    setActive(index) {
      // if(type == 'C' || type == 'D') {
      //   this.active1 = index + type;
      //   this.active = index;
      //   return;
      // }
      this.active = index;
    },
    validateEmail(email) {
      return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    onKeyUp: function (event, name) {
      let emailreg =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (name == "email") {
        this.status.emailStatus = emailreg.test(this.email);
        if (!this.status.emailStatus) {
          this.showPaymentCollapse = false;
        }
        ///check Mobile validation
      } else if (name == "mobile") {
        console.log(event.isValid);
        this.status.phoneNumberStatus = false;
        this.showPaymentCollapse = false;
        if (event.isValid) {
          this.status.phoneNumberStatus = true;
          this.showPaymentCollapse = false;
        }
      }
      // else if (name == "conditions") {
      //   if (!this.conditions) {
      //     this.showPaymentCollapse = false;
      //   }
      // }
      else if (name == "offer") {
      }
    },
    applyVoucher() {
      const { reseverID } = this.$route.params;

      let payload = {
        event_reserve_id: reseverID,
        voucher_code: this.voucherCode,
      };
      makeRequest("/v1/voucher/apply", "POST", null, payload, this.url)
        .then((response) => {
          const { error, res } = response;
          if (!error) {
            this.hideLoading();
            console.log(res);
            if (res.data.error) {
              this.voucherMsg = res.data.error;
            } else {
              this.voucherMsg = res.data.message;
              this.getReserveDetails(reseverID);
            }
          } else {
            console.log("Response Error ", error);
          }
        })
        .catch((error) => {
          console.log("Error", error);
        });
    },
    getReserveDetails(id) {
      this.showLoading();
      makeRequest("/v1/event/detailreserve/" + id, "POST", null, null, this.url)
        .then((response) => {
          const { error, res } = response;
          if (!error) {
            this.hideLoading();
            this.es_date = res.data.data.schedule.es_date;
            this.es_time = res.data.data.schedule.es_time;
            this.e_name = res.data.data.event_detail.e_name;
            this.e_img = res.data.data.event_detail.e_image;
            this.e_venue = res.data.data.venue;
            let temp5 = res.data.data.seat_info;
            let temp4 = {};
            let temp6 = [];
            this.paymentTotal = 0;
            this.paymentTotalBeforeDiscount = 0;
            this.currencyCode = res.data.data.seat_info[0].currency;
            temp5.map((d) => {
              this.paymentTotal += parseFloat(d.total_price);
              this.paymentTotalBeforeDiscount += parseFloat(d.total_price);
              if (temp4[d.seat_type_id]) {
                let no_of_seat = parseInt(temp4[d.seat_type_id].no_of_seat) + 1;
                let total_price = parseFloat(d.price) * parseFloat(no_of_seat);
                let sl_name = temp4[d.seat_type_id].sl_name + "," + d.sl_name;

                temp4[d.seat_type_id] = {
                  st_name: d.st_name,
                  sl_name: sl_name,
                  no_of_seat: no_of_seat,
                  qty: no_of_seat,
                  price: d.price,
                  currency: d.currency,
                  total_price: total_price,
                };
              } else {
                temp4[d.seat_type_id] = {
                  st_name: d.st_name,
                  sl_name: d.sl_name,
                  no_of_seat: d.no_of_seat,
                  qty: d.no_of_seat,
                  price: d.price,
                  currency: d.currency,
                  total_price: d.total_price,
                };
              }
            });
            console.log("temp4 :>> ", temp4);
            let allkeys = Object.keys(temp4);
            allkeys.map((d) => {
              temp6.push(temp4[d]);
            });

            if (res.data.data.voucher) {
              this.discount = res.data.data.voucher.discount;
              this.paymentTotal -= this.discount;
            }

            this.getSelectedSeats = temp6;
            this.base_url = res.data.base_url;
            if (res.data.data.voucher != null) {
              this.voucherDetails = res.data.data.voucher;
              console.log(this.voucherDetails);
            }
            // this.eventDetails = res.data.data;
            // this.addSelectedEvent(res.data.data);
            // this.getEventSchedule(
            //   res.data.data.venue[0].auditorium[0].schedule
            // );
          } else {
            console.log("Response Error ");
          }
        })
        .catch((error) => {
          console.log("Error", error);
        });
    },

    getPaymentOptions() {
      makeRequest("/v1/payment/", "GET", null, null, this.url)
        .then((response) => {
          const { error, res } = response;
          if (!error) {
            this.payment_options = res.data.data;
            console.log(this.payment_options);
          } else {
            console.log("Response Error ");
          }
        })
        .catch((error) => {
          console.log("Error", error);
        });
    },

    addPaymentTotal() {
      this.getSelectedSeats.map((data) => {
        console.log(data, data.cost, this.paymentTotal);
        this.paymentTotal =
          parseFloat(data.cost) + parseFloat(this.paymentTotal);
        this.paymentTotalBeforeDiscount =
        parseFloat(data.cost) + parseFloat(this.paymentTotalBeforeDiscount);
      });
    },
    validateBeforeSubmit() {
      if (this.checkoutButtonStatus) {
        this.showPaymentCollapse = true;
      }
      setTimeout(() => {
        let elmnt = document.getElementById("payment");
        console.log(elmnt);
        elmnt.scrollIntoView({ behavior: "smooth", inline: "start" });
      }, 0);
    },
  },
};
</script>
<style>
.tickets-grid {
  display: grid;
  grid-template-columns: 70% 30%;
  align-items: center;
}
.card-img {
  width: 100px;
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/paymentSummary.vue